import { Alert, Button, Content, Split, SplitItem, Stack, StackItem } from "@patternfly/react-core";
import type { FC } from "react";
import { useProductMetadata } from "../../hooks/useProductMetadata";
import { validateAttachedProjects } from "../../utils/attachedProjectValidator";
import ProductComponentsTable from "../ProductComponents/ProductComponentsTable";

interface ICertAndValidationProps {
	goToAddComponents: () => void;
}
const CompleteCertificationTesting: FC<ICertAndValidationProps> = ({ goToAddComponents }) => {
	const {
		productDetail,
		activeCertificationListState,
		componentMetadata: { isCertifiedProduct },
	} = useProductMetadata();
	const isProductCertified =
		validateAttachedProjects(productDetail, activeCertificationListState, false) && isCertifiedProduct;
	return (
		<Stack hasGutter={true}>
			<StackItem>
				<Content>
					<Content component="h2">Complete certification testing</Content>
				</Content>
			</StackItem>
			{isProductCertified ? (
				<StackItem>
					<Alert variant={"success"} title={"Certification complete"} isInline={true} isPlain={true}>
						To certify your product for other versions of Red Hat platforms, review the added components and follow
						their certification steps.
					</Alert>
				</StackItem>
			) : (
				<StackItem>
					<Alert
						variant={"warning"}
						title={"Your product has not passed all required tests"}
						isInline={true}
						isPlain={true}
					>
						Certify all attached components individually to complete your product certification.
						<br />
						Review non-certified components and complete their certification steps to certify your product.
					</Alert>
				</StackItem>
			)}
			<StackItem>
				<ProductComponentsTable
					hideActiveFilter={true}
					isMiniTable={true}
					hideAddComponentButton={true}
					hideContextMenu={true}
					switchableTypeColumn={"certificationStatus"}
				/>
			</StackItem>
			<StackItem>
				<Split hasGutter={true}>
					<SplitItem>
						<Button onClick={goToAddComponents} variant={"secondary"}>
							Edit attached components
						</Button>
					</SplitItem>
				</Split>
			</StackItem>
		</Stack>
	);
};

export default CompleteCertificationTesting;
